import React, { useState, useEffect } from 'react'
import { addDays } from 'date-fns'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Icon,
  Text
} from '@chakra-ui/react'
import { CustomDatePicker, Search, SquareButton, Select, Select2 } from '../UI'
import { ReplayIcon } from '../Icons'
import { GetStatus, GradesCarabineros } from '../../Utils'

const FiltersPartners = ({
  filtersPartners,
  setFiltersPartners,
  initialFiltersPartners,
  children
}) => {
  const [gradesList, setGradesList] = useState([])
  const handleChangeSearch = (e) => {
    setFiltersPartners({
      ...filtersPartners,
      search: e.target.value
    })
  }

  const handleChangeStartDate = (date) => {
    setFiltersPartners({
      ...filtersPartners,
      startDate: date
    })
  }

  const handleChangeEndDate = (date) => {
    setFiltersPartners({
      ...filtersPartners,
      endDate: date
    })
  }

  const handleChangeGrade = (grade) => {
    setFiltersPartners({
      ...filtersPartners,
      grade
    })
  }

  const handleChangeState = (state) => {
    setFiltersPartners({
      ...filtersPartners,
      state
    })
  }

  const resetFilters = () => {
    setFiltersPartners(initialFiltersPartners)
  }

  useEffect(() => {
    const all_grades = ['Todos los Grados']
    GradesCarabineros.map((grade) => {
      all_grades.push(grade)
      return grade
    })
    setGradesList(all_grades)
  }, [])

  return (
    <Flex gap={4} direction={'column'}>
      <Flex gap={3} justify={'space-between'} align={'center'}>
        <Box>
          <Search
            onChange={handleChangeSearch}
            currentValue={filtersPartners.search}
            showBtn={false}
          />
        </Box>

        {children}
      </Flex>
      <Accordion allowMultiple>
        <AccordionItem>
          <AccordionButton>
            <Box flex="1" textAlign="left">
              <Text whiteSpace={'nowrap'} fontWeight={700} color={'green.500'}>
                Filtros:
              </Text>
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel>
            <Flex gap={3} direction={'column'}>
              <Flex
                gap={4}
                align={'center'}
                justify={'space-between'}
                direction={{
                  lg: 'row',
                  md: 'column-reverse',
                  sm: 'column-reverse'
                }}
              >
                <Flex
                  gap={4}
                  direction={{
                    lg: 'row',
                    md: 'column',
                    sm: 'column'
                  }}
                >
                  <Flex w={400} gap={2} align={'center'}>
                    <Text whiteSpace={'nowrap'} fontWeight={700}>
                      Fecha desde:
                    </Text>
                    <CustomDatePicker
                      placeholder={'DD/MM/AAAA'}
                      currentDate={filtersPartners.startDate}
                      onChange={(date) => {
                        handleChangeStartDate(date)
                      }}
                      maxDate={addDays(new Date(), 0)}
                    />
                  </Flex>
                  <Flex w={400} gap={2} align={'center'}>
                    <Text whiteSpace={'nowrap'} fontWeight={700}>
                      Fecha hasta:
                    </Text>
                    <CustomDatePicker
                      placeholder={'DD/MM/AAAA'}
                      currentDate={filtersPartners.endDate}
                      onChange={(date) => {
                        handleChangeEndDate(date)
                      }}
                      maxDate={addDays(new Date(), 1)}
                    />
                  </Flex>
                </Flex>
                <Box
                  marginRight={{
                    lg: 0,
                    md: 'auto',
                    sm: 'auto'
                  }}
                >
                  <SquareButton onClick={resetFilters}>
                    <Icon as={ReplayIcon} />
                  </SquareButton>
                </Box>
              </Flex>
              <Flex
                gap={4}
                direction={{
                  lg: 'row',
                  md: 'column',
                  sm: 'column'
                }}
              >
                <Box
                  w={{
                    lg: '25%',
                    md: '100%',
                    sm: '100%'
                  }}
                >
                  <Text whiteSpace={'nowrap'} fontWeight={700}>
                    Grado:
                  </Text>
                  <Select
                    list={gradesList}
                    onChange={handleChangeGrade}
                    value={filtersPartners?.grade}
                  />
                </Box>
                <Box
                  w={{
                    lg: '25%',
                    md: '100%',
                    sm: '100%'
                  }}
                >
                  <Text whiteSpace={'nowrap'} fontWeight={700}>
                    Status:
                  </Text>
                  <Select2
                    list={GetStatus.partner}
                    onChange={handleChangeState}
                    value={filtersPartners?.state}
                  />
                </Box>
              </Flex>
            </Flex>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Flex>
  )
}

export default FiltersPartners
